import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import css from 'classnames'
import { MdOutlineConfirmationNumber } from 'react-icons/md'
import { LogoutButton } from '~/features/auth'
import { UserInfo, SVGSetting } from '~/shared/ui'
import { useStore } from '~/app/store'

export const NavUser = observer(() => {
  const { t } = useTranslation('tickets')
  const {
    usersStore: { userProfile },
    ticketsStore: { hasUnreadUpdates },
  } = useStore()
  const navIconClassName = ({ isActive }: { isActive: boolean }) =>
    css(
      'text-xl flex items-start justify-center relative group text-gray-900',
      {
        '[&>.icon]:opacity-100 [&>.icon]:w-full': isActive,
      },
    )

  return (
    <div className="flex shrink-0 items-center gap-6 px-2">
      <div className="flex items-center gap-4">
        <NavLink
          to="/tickets"
          className={navIconClassName}
          aria-label={
            hasUnreadUpdates ? t('ticketsUnreadUpdates') : t('tickets')
          }
        >
          <span className="icon hidden md:block absolute opacity-0 group-hover:opacity-100 group-hover:w-full transition-all bottom-[-10px] left-0 right-0 w-0 bg-blue-600 h-[3px] rounded" />
          <MdOutlineConfirmationNumber size={24} />
          {hasUnreadUpdates && (
            <span
              aria-hidden="true"
              className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"
            />
          )}
        </NavLink>
        <NavLink to="/settings" className={navIconClassName}>
          <span className="icon hidden md:block absolute opacity-0 group-hover:opacity-100 group-hover:w-full transition-all bottom-[-10px] left-0 right-0 w-0 bg-blue-600 h-[3px] rounded" />
          <SVGSetting />
        </NavLink>
        <UserInfo
          name={userProfile?.name}
          email={userProfile?.email}
          id={userProfile?.id}
        />
      </div>
      <LogoutButton />
    </div>
  )
})
